<template>
  <q-dialog v-model="shown">
    <q-card style="min-width: 200px; width: 90vw; max-width: 400px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Select Modifiers
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <q-btn
          color="primary"
          class="q-mb-md full-width"
          @click="$emit('create-modifier', newModel)"
        >
          Create New Modifier
        </q-btn>
        <q-input
          v-model="searchString"
          class="q-mb-md"
          label="Search"
          dense
          clearable
          debounce="300"
        />
        <div
          class="relative-position"
          style="min-height: 200px; max-height: 70vh; overflow-y: auto;"
        >
          <q-list
            bordered
            separator
          >
            <q-item
              v-for="modifier in filteredModifiers"
              :key="modifier.id"
              clickable
              @click.stop="toggleModifier(modifier)"
            >
              <q-item-section avatar>
                <q-checkbox
                  class="no-pointer-events"
                  :model-value="!!$_.find(modifierSet.modifierIds || [], id => id === modifier.id)"
                />
              </q-item-section>
              <q-item-section>
                <q-item-label>
                  {{ modifier.name }}
                </q-item-label>
              </q-item-section>
              <q-item-section>
                {{ modifier.price }}
              </q-item-section>
            </q-item>
          </q-list>
          <q-inner-loading :showing="modifiers.loading" />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import ModifierSet from 'src/models/modifier-set/ModifierSet'

export default {
  name: 'SelectModifiersDialog',
  props: {
    modifierSet: {
      type: ModifierSet,
      required: true
    }
  },
  configuration: ['modifiers'],
  emits: ['create-modifier'],
  data () {
    return {
      shown: false,
      newModel: null,
      searchString: ''
    }
  },
  computed: {
    filteredModifiers () {
      const activeModifiers = _.filter(this.modifiers.data, 'isUnarchived')
      if (this.searchString) {
        return activeModifiers.filter(modifier => modifier.name.toLowerCase().includes(this.searchString.toLowerCase()))
      }
      return activeModifiers
    }
  },
  methods: {
    show (model) {
      this.newModel = model
      this.shown = true
    },
    toggleModifier (modifier) {
      const currentModifierIds = this.modifierSet.modifierIds || []
      const isSelected = _.includes(currentModifierIds, modifier.id)

      if (isSelected) {
        // Remove the modifier by reassigning the array
        this.modifierSet.modifierIds = _.without(currentModifierIds, modifier.id)
      } else {
        // Add the modifier by reassigning the array
        this.modifierSet.modifierIds = [...currentModifierIds, modifier.id]
      }
    }
  }
}
</script>
